import React from 'react';

import CreateTrplBtn from './CreateTrplBtn';
import TrplTextfield from '../../TrplControls/TrplTextfield';
import SetDeleteTrplBtns from '../TrplFormRowComponents/SetDeleteTrplBtns';

import TrplErrorAlertIcon from './TrplErrorAlertIcon';
import MandatoryAlertIcon from './MandatoryAlertIcon';

import CopyBtn from '../../CopyBtn';
import ArrowTooltipCss from '../../ArrowTooltipCss';
import { shouldShowTrplAsEdited } from '../../../utils';

export default ({
  rst,
  trpls,
  type,
  groupId,
  classes,
  setTrpl,
  constant,
  isVirtual,
  isNewNode,
  ancestorId,
  loadingTids,
  deletedTids,
  hideSetDelete,
  isAnotherNode,
  onRstValueEdit,
  setLoadingTids,
  removeTrplValue,
  setDeletedTrplId,
  resetDeletedTrplId,
  showMandatoryAlert,
  disableTrplEditing,
  updateDataOnRestoreTrpl,
}) => {
  const notEditable = constant || disableTrplEditing;
  return (
    <React.Fragment>
      {trpls.map((trpl, trplIndex) => {
        const inputProps = {
          classes: {
            input: `${classes.trplTextUrlInput} ${!trpl.tid && trpl.unsaved ? classes.unsavedNewTrpl : ''} ${
              shouldShowTrplAsEdited(trpl)
              ? classes.trplEdited
              : showMandatoryAlert
                ? classes.mandatoryField
                : isVirtual && notEditable
                  ? classes.notEditableVirtualTrpl
                : isVirtual
                  ? classes.trplVirtual
                  : notEditable && trpl && trpl.tid
                  ? classes.notEditableTrplWithValue
                  : trpl.tid
                    ? classes.trplWithValue
                    : classes.trplEmpty
            }`,
          },
        };

        return (
          <div key={`${rst.title}.${trplIndex}`}
            className={
              `${classes.relative} ${classes.spaceBetween} ${classes.alignCenter} ${trplIndex === 0 ? '' : classes.mt5}`
            }
          >
            {trpl.tid ?
              <React.Fragment>
                <div className={`hidden-scroll ${classes.trplFileLinkContainer} ${classes.fillAvailable}`}>
                  <a target="blank" href={trpl.val} className={`${classes.trplFileLink}`}>
                    <span>{trpl.val || "\u200B"}</span>
                  </a>
                </div>

                <TrplErrorAlertIcon trpl={trpl} />

                <ArrowTooltipCss text="Copy to clipboard">
                  <CopyBtn
                    text={trpl.val}
                    copyIconStyles={{
                      marginLeft: '10px',
                      fontSize: '18px',
                    }}
                  />
                </ArrowTooltipCss>

                <SetDeleteTrplBtns
                  rst={rst}
                  type={type}
                  trpl={trpl}
                  groupId={groupId}
                  classes={classes}
                  setTrpl={setTrpl}
                  trplIndex={trplIndex}
                  ancestorId={ancestorId}
                  loadingTids={loadingTids}
                  isAnotherNode={isAnotherNode}
                  setLoadingTids={setLoadingTids}
                  removeTrplValue={removeTrplValue}
                  setDeletedTrplId={setDeletedTrplId}
                  constant={constant || disableTrplEditing}
                />
              </React.Fragment>

              :

              <React.Fragment>
                <TrplTextfield
                  fullWidth
                  margin="none"
                  value={trpl.val}
                  InputProps={inputProps}
                  disabled={disableTrplEditing}
                  onChange={(e) => onRstValueEdit(
                    rst, e.target.value, trplIndex, isAnotherNode && ancestorId,
                  )}
                />

                {showMandatoryAlert && <MandatoryAlertIcon />}
                
                {hideSetDelete ? null :
                  <CreateTrplBtn
                    rst={rst}
                    trpl={trpl}
                    classes={classes}
                    setTrpl={setTrpl}
                    trplIndex={trplIndex}
                    isNewNode={isNewNode}
                    ancestorId={ancestorId}
                    loadingTids={loadingTids}
                    deletedTids={deletedTids}
                    isAnotherNode={isAnotherNode}
                    setLoadingTids={setLoadingTids}
                    disableTrplEditing={disableTrplEditing}
                    resetDeletedTrplId={resetDeletedTrplId}
                    updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
                  />
                }
              </React.Fragment>
            }
          </div>
        )
      }
      )}
    </React.Fragment>
  )
};
